
import { defineComponent } from "vue";
import { getaccountlist, resetLocalCache } from "@/api/common";
import { vGetPackageType, vGetOtherOtherMenuToggleValues} from '@/api/dashboard.js';

import { getCurrentUser, setCurrentUser} from "@/utils/index";
import {getUserCountryCode} from '@/api/dashboard';


export default defineComponent({
  name: "accountlist-menu",
  components: {},
  data() {
    return {
      accountlist: [],
      currentUsid: "",
      isBibo : false,
      ccode : -1
    }
  },
  setup() {  
    return { 
       
    };
  },
  methods: {
    async getAccountList() {
      const response = await getaccountlist();
        let self = this;
        if(response.data !== undefined && response.data.accounts !== undefined) {

          if(localStorage.getItem("pt") == 'bibo'){
            this.isBibo = true;
          } else {
            this.isBibo = false;
          }

          self.accountlist = response.data.accounts;

           
        }
    },
    async getUserCcode(){ 
      const response = await getUserCountryCode();
      this.ccode = response.data.ccode;
      localStorage.setItem("ccode", String(this.ccode));

      resetLocalCache();

      setTimeout(() => {
              window.location.reload();
          }, 1000);
    }, 
    async vGetPackageType(){
			const response = await vGetPackageType(); 
			if(response.data !== undefined ) {
        localStorage.setItem("pVaAcNkPaOgGeItRyEpAeL", response.data.packageType);
        this.getUserCcode();
			}
		},
    async vGetOtherOtherMenuToggleValuesFN(){
      const response = await vGetOtherOtherMenuToggleValues(); 
      if(response.data !== undefined ) {
          if(response.data.isShowAutoPMA == true){
            localStorage.setItem("sXhYoZwAABuCtDoEPFMGA", "true");
          } else {
            localStorage.setItem("sXhYoZwAABuCtDoEPFMGA", "false");
          }

          if(response.data.isShowUSTripMonitoringPage == true){
            localStorage.setItem("sXhYoZwAuBsCtDrEiFp", "true");
          } else {
            localStorage.setItem("sXhYoZwAuBsCtDrEiFp", "false");
          }

          if(response.data.isShowPCPMenu == true){
            localStorage.setItem("sVhAoNwPPOCGPIM1e2n3u", "true");
          } else {
            localStorage.setItem("sVhAoNwPPOCGPIM1e2n3u", "false");
          }
      }
    },

    changeAccount(a){
        let user = getCurrentUser();
        user.usid = a;
        setCurrentUser(user);
        localStorage.ec_current_usid = a;

        this.vGetPackageType();
        this.vGetOtherOtherMenuToggleValuesFN();
          
    }
    
  },
  mounted() {
    
      let user = getCurrentUser();

      this.getAccountList();

      this.currentUsid = user.usid;
      
  }
});
